<script>
import {
  defineComponent,
  inject,
  markRaw,
  nextTick,
  onMounted,
  ref,
} from "vue";
import { InjectionKeys, Functions, Utilities } from "@vue-leaflet/vue-leaflet";
const { setupControl, controlProps } = Functions.Control;
const { RegisterControlInjection } = InjectionKeys;
const { assertInject, propsBinder } = Utilities;
import { geosearch } from "esri-leaflet-geocoder";

/**
 * Add any custom component as a leaflet control-zoom
 */
export default defineComponent({
  name: "EControlGeocoder",
  props: {
    ...controlProps,
    providers: {
      type: Array,
    },
    useMapBounds: {
      type: [Boolean, Number],
      default: 12,
    },
    collapseAfterResult: {
      type: Boolean,
      default: true,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    allowMultipleResults: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: "Search for places or addresses",
    },
    title: {
      type: String,
      default: "Location Search",
    },
    zoomToResult: {
      type: Boolean,
      default: true,
    },
    searchBounds: {
      type: Object,
      default: null,
    },
  },
  setup(props, context) {
    const leafletObject = ref();
    const registerControl = assertInject(RegisterControlInjection);

    const { options, methods } = setupControl(props, leafletObject);

    onMounted(async () => {
      leafletObject.value = markRaw(geosearch({ ...props, ...options }));
      propsBinder(methods, leafletObject.value, props);
      registerControl({ leafletObject: leafletObject.value });
      leafletObject.value.on("results", (data) =>
        context.emit("results", data)
      );
      await nextTick(() => context.emit("ready", leafletObject.value));
    });

    return { leafletObject };
  },

  render() {
    return null;
  },
});
</script>
